var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOpenapiPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "#27AB27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.975 13.3276C11.825 12.8532 14 10.3336 14 7.29654C14 3.92133 11.3137 1.18518 8 1.18518C4.68629 1.18518 2 3.92133 2 7.29654C2 10.4011 4.27277 12.965 7.21604 13.3562L8.08709 14.8338L8.975 13.3276Z",
    fill: "#FDFFFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_796_4859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4847 5.19794V6.43348C5.06644 6.48605 4.7369 6.27575 4.6862 5.94715V5.19794C4.64817 4.79048 5.2819 3.92297 5.92831 3.92297H10.0222C10.4912 3.92297 11.2136 4.51445 11.2516 5.19794V5.94715C11.239 6.27575 10.9094 6.43348 10.4531 6.43348V5.19794C10.4607 5.05348 10.4264 5.01135 10.2884 5.01393H5.63679C5.51417 5.01437 5.48043 5.05399 5.4847 5.19794Z",
    fill: "#27AB27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21777 5.06653C4.32914 4.96556 4.39561 4.96114 4.52196 5.06653V5.90774C4.40821 5.97792 4.34161 5.97983 4.21777 5.90774V5.06653Z",
    fill: "#27AB27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3916 5.06653C11.503 4.96556 11.5694 4.96114 11.6958 5.06653V5.90774C11.582 5.97792 11.5154 5.97983 11.3916 5.90774V5.06653Z",
    fill: "#27AB27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77539 8.01172C4.77539 7.45943 5.22311 7.01172 5.77539 7.01172H10.138C10.6903 7.01172 11.138 7.45943 11.138 8.01172V9.27143C11.138 9.75945 10.7884 10.1658 10.326 10.2538C10.3265 10.264 10.3268 10.2743 10.3268 10.2847C10.3268 10.6114 10.0714 10.8762 9.75644 10.8762C9.44144 10.8762 9.18609 10.6114 9.18609 10.2847C9.18609 10.2803 9.18613 10.2758 9.18623 10.2714H6.72719L6.72733 10.2847C6.72733 10.6114 6.47197 10.8762 6.15697 10.8762C5.84197 10.8762 5.58662 10.6114 5.58662 10.2847C5.58662 10.2743 5.58688 10.264 5.58738 10.2538C5.12497 10.1658 4.77539 9.75945 4.77539 9.27143V8.01172Z",
    fill: "#27AB27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.14453,
    y: 4.22534,
    width: 3.59958,
    height: 0.6572,
    rx: 0.3286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.14476,
    cy: 8.56278,
    rx: 0.456285,
    ry: 0.473184,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.74437,
    cy: 8.56278,
    rx: 0.456285,
    ry: 0.473184,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_796_4859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.57143,
    height: 7.11111,
    fill: "white",
    transform: "translate(3.71387 3.85181)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpenapiPaid);
export default __webpack_public_path__ + "static/media/ic-openapi-paid.71b7adc001842bf39db896372231ccf8.svg";
export { ForwardRef as ReactComponent };